export enum ClientStatusEnum {
  Inactive = 1,
  Active,
  Closed,
  Cancelled,
  'Service Provider'
}

export namespace ClientStatusEnum {
  export function values() {
    return Object.keys(ClientStatusEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
